import React from 'react';

/**
 * Site mark: official Costco Wholesale wordmark + "Chase" suffix.
 * Logo asset sourced from costco.com (trademark Costco Wholesale; fan site — see footer disclaimer).
 */
function CostcoLogo({ className = '', suffix = 'Chase', compact = false }) {
	const logoSrc = `${process.env.PUBLIC_URL || ''}/assets/costco/costco-logo.png`;

	return (
		<span className={`costco-logo ${compact ? 'costco-logo--compact' : ''} ${className}`.trim()}>
			<img
				className="costco-logo__mark"
				src={logoSrc}
				alt="Costco Wholesale"
				width={compact ? 120 : 156}
				height={compact ? 35 : 45}
				decoding="async"
			/>
			{suffix ? <span className="costco-logo__suffix">{suffix}</span> : null}
		</span>
	);
}

export default CostcoLogo;
